export const onSelectHandler = (onChange, event, value, text, index) => {
  if(typeof onChange !== 'function') {
    return;
  }
  onChange(event, value, text, index);
}
